<template>
  <Layout style="height: 100%" class="main">
    <Sider
      hide-trigger
      collapsible
      :width="256"
      :collapsed-width="64"
      v-model="collapsed"
      class="left-sider"
      :style="{ overflow: 'hidden' }"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :active-name="activeName || $route.name"
        :collapsed="collapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <!-- 改成汉字 -->
          <div v-show="!collapsed">
            <img
              :src="maxLogo"
              key="min-logo"
              style="width: 24px; height: 24px; display: inline-block; vertical-align: middle;margin-right: 5px;"
            />
            <span class="mainTitle">91管理系统</span>
          </div>
          <!-- <img v-show="!collapsed" :src="maxLogo" key="max-logo" /> -->
          <img
            v-show="collapsed"
            :src="minLogo"
            key="min-logo"
            style="width: 24px; height: 24px; margin: 10px auto;"
          />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
          <div class="mr10 info">
            <span class="name-circle mr10">
              {{ userInfo.name && userInfo.name[0] }}
            </span>
            <Dropdown transfer>
              <div style="cursor: pointer">
                <span>
                  {{ userInfo.name || '' }}
                </span>
                <Icon type="ios-arrow-down" style="margin-left: 2px"></Icon>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem>
                  <div @click="loginOut">退出登录</div>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <Select
            @on-select="systemDidChange"
            v-model="currentSystem"
            style="width:200px; z-index: 999;margin: 15px 30px 10px;"
            transfer
          >
            <Option
              v-for="item in canLoginSystemList"
              :value="item.id"
              :key="item.id"
            >
              {{ item.label }}
            </Option>
          </Select>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav
              :value="$route"
              @input="handleClick"
              :list="tagNavList"
              @on-close="handleCloseTag"
            />
          </div>
          <Content class="content-wrapper" id="content-wrapper">
            <keep-alive :include="cacheList">
              <router-view />
            </keep-alive>
            <img
              v-if="isShowBg"
              class="bgWelcome"
              src="./assets/images/common/welcome.png"
              alt="欢迎"
            />
          </Content>
        </Layout>
      </Content>
    </Layout>
    <Button
      @click="goTop"
      type="primary"
      shape="circle"
      icon="md-arrow-round-up"
      style=" padding: 0px; width: 40px; font-size: 25px; height: 40px;position: fixed; bottom: 10px; right: 10px;z-index: 99999;"
      v-show="isShowToTop"
    ></Button>
  </Layout>
</template>
<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import SideMenu from '@/components/side-menu';
import HeaderBar from '@/components/header-bar';
import TagsNav from '@/components/tags-nav';
import routers from './router/modules';
import util from '@assets/js/util';
import '@assets/styles/homepage/index.less';
import jsCookie from 'js-cookie';
export default {
  name: 'myMain',
  data() {
    return {
      // 当前选中的系统
      currentSystem: process.env.VUE_APP_HOST_APPID,
      activeName: '',
      isShowBg: true,
      collapsed: false, // 是否缩略图模式
      isShowToTop: false, // 是否显示回到顶部
      userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},
      minLogo: require('./assets/images/index/index_title.png'), // 小lOGO
      maxLogo: require('./assets/images/index/index_title.png') // 大 logo
    };
  },
  computed: {
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    cacheList() {
      const list = [
        'ParentView',
        'commonRouterView',
        ...(this.tagNavList.length
          ? this.tagNavList
            .filter(item => !(item.meta && item.meta.notCache))
            .map(item => item.name)
          : [])
      ];
      return list;
    },
    menuList() {
      // tree data
      return this.$store.getters.menuList;
    },
    canLoginSystemList() {
      return this.$store.state.app.canLoginAppList;
    }
  },
  methods: {
    ...mapMutations([
      'setHomeRoute',
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'closeTag'
    ]),
    ...mapActions(['getCanLoginAppList']),
    turnToPage(route) {
      // tree 节点click
      let { name, params, query } = {};
      if (typeof route === 'string') name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (this.$route.name && this.$route.name == name) return;
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query
      });
    },
    handleCollapsedChange(state) {
      // 左侧展开/收缩
      this.collapsed = state;
    },
    loginOut() {
      this.$Modal.confirm({
        title: '退出登录',
        content: '<p>确认退出系统吗？</p>',
        onOk: () => {
          this.$ajax('/v1/userInfo/logout').then(res => {
            const { code } = res.data;
            if (code == 200) {
              jsCookie.remove('Admin-token', {
                domain: process.env.VUE_APP_TOKEN_DOMAIN
              });
              this.$router.push('/login');
            }
          });
        }
      });
    },
    setPageHeight() {
      const aside = document.getElementById('content-wrapper');
      const minHeight = document.body.clientHeight;
      aside.style.minHeight = `${minHeight - 130}px`;
    },
    scrollToTop() {
      const scrollTopVal = document.getElementById('content-wrapper').scrollTop;
      if (scrollTopVal > 200) {
        this.isShowToTop = true;
      } else {
        this.isShowToTop = false;
      }
    },
    goTop() {
      document.getElementById('content-wrapper').scrollTop = 0;
    },
    handleCloseTag(res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName);
        } else {
          if (util.routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    requestcanLoginSystemList() {
      this.getCanLoginAppList();
    },
    systemDidChange(item) {
      const { appUrl } = this.canLoginSystemList.find(i => i.id == item.value);
      if (appUrl) {
        window.open(appUrl);
      }
    }
  },
  watch: {
    $route(newRoute, oldRoute) {
      // 面包屑设置
      this.isShowBg = newRoute.name == 'home';
      if (!newRoute.meta.hideInMenu) {
        this.setBreadCrumb(this.$route);
        this.$refs.sideMenu.updateOpenName(newRoute.name);
      }
      this.activeName = newRoute.name;
      const { name, query, params, meta } = newRoute;
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      });
      this.setTagNavList(util.getNewTagList(this.tagNavList, newRoute));
      this.$store.commit('changeFooterButtonArr', []); // 更新是否显示footer按钮
    }
  },
  mounted() {
    this.requestcanLoginSystemList();
    this.setTagNavList();
    const { name, params, query, meta } = this.$route;
    this.addTag({ route: { name, params, query, meta } });
    this.setHomeRoute(routers);
    this.setBreadCrumb(this.$route);
    this.isShowBg = this.$route.name == 'home';
    this.setPageHeight();
    window.onresize = () => {
      this.setPageHeight();
    };
    document
      .getElementById('content-wrapper')
      .addEventListener('scroll', this.scrollToTop);
  },
  components: {
    SideMenu,
    HeaderBar,
    TagsNav
  }
};
</script>
<style scoped>
#content-wrapper {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
  will-change: transform;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.logo-con {
  height: 48px;
  overflow: hidden;
  padding: 12px 10px 0px 10px;
  margin-bottom: 16px;
  text-align: center;
}
.bgWelcome {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -300px;
  margin-left: -300px;
  max-width: 600px;
}
.info {
  display: flex;
  align-items: center;
}
.info .name-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  background: #eee;
}
</style>
